
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getIntenttype} from 'sr/utils/api/masterData/intenttype/getIntenttype'
export const fetchintenttype = createAsyncThunk(
  'getIntenttype',
  async () => {
    const response = await getIntenttype()
    return response?.data
  }
)


